import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class PickListService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  generatePickList(body: any) {
    return this.http.post(`${this.baseUrl}/pick-list/picklist/preview`, body);
  }

  getPicklists(
    page: number,
    limit: number,
    picklistNo?: string
  ): Observable<any> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString());

    if (picklistNo) {
      params = params.set('query', picklistNo);
    }
    return this.http.get(`${this.baseUrl}/pick-list`, { params });
  }

  getPicklistById(id: string) {
    return this.http.get(`${this.baseUrl}/pick-list/${id}`);
  }

  getNextPickListNumber(): Observable<any> {
    return this.http.get(`${this.baseUrl}/pick-list/next-number`);
  }
  savePickList(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/pick-list`, payload);
  }

  getPickListDetails(id: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/pick-list/${id}/details`);
  }

  updatePickListStatus(id: string, payload?: any): Observable<any> {
    return this.http.patch(`${this.baseUrl}/pick-list/${id}/status`, payload);
  }

  downloadPickList(id: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/pick-list/download/${id}`, {
      responseType: 'blob',
    });
  }
}
